// extracted by mini-css-extract-plugin
module.exports = {"desktopLayout":"style_desktopLayout__qzMv_"};